module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_RO-64f1ec18869e4a9e0c9d60c0d35c77a8.svg";